module.exports = __webpack_public_path__ + "static/media/used-cars-bg-smoke.fe50ee81.png";